<template>
  <overview-layout ref="overview" :tableCfg="tableCfg">
    <template slot="AdvancedFilter">
      <b-form ref="form" class="offset-md-1" autocomplete="off">
        <div class="row">
          <detail-field class="col-md-6" label="Name" field="name" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
          <detail-field class="col-md-6" label="Email Address" field="email_address" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
          <detail-field class="col-md-6" label="Address" field="address" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
          <detail-field class="col-md-6" label="Bank info requested before" type="date" field="bankinfo_requested_before" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
          <detail-field class="col-md-6" label="Bank info updated before" type="date" field="bankinfo_updated_before" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
        </div>
      </b-form>
    </template>
    <template slot="ExtraOptions" scope="props">
        <b-dropdown variant="default" size="sm">
          <template slot="button-content"> <i class="fa fa-cog"></i> </template>
          <b-dropdown-item @click="exportSelection('/students/download_report', 'Students.xlsx')">Export Selection</b-dropdown-item>
        </b-dropdown>
    </template>
  </overview-layout>
</template>

<script>
import OverviewMixin from '../../components/OverviewMixin'
import FieldDefs from './FieldDefs.js'

export default {
  name: 'student_overview',
  mixins: [OverviewMixin],
  data () {
    return {
      tableCfg: FieldDefs
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// Overview.vue?117dbb3a